// The admin's bar on a page they write in place — a chapter, a post. Out of
// edit mode it offers Edit; in it, Publish, Delete, Done and Save.
import type { CommentaryStatus } from "@bibleunleashed/shared";
import { BottomBar } from "./BottomBar";
import { Icon } from "./Icon";

export function AdminBar(props: {
  editing: boolean;
  dirty: boolean;
  status: CommentaryStatus;
  saving: boolean;
  error?: string;
  exists: boolean;
  onEdit: () => void;
  onDone: () => void;
  onSave: () => void;
  onPublish: () => void;
  onDelete: () => void;
}) {
  const btn = "rounded-md px-3 py-1.5 text-[13px]";
  return (
    <BottomBar>
      <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-2 px-6 py-2.5 lg:px-10">
        <span className="font-sans text-[11px] tracking-[0.08em] text-ink-3 uppercase">
          {props.status === "published" ? "Published" : "Draft"}
          {props.dirty && " · unsaved"}
        </span>
        {props.error && <span className="text-[12px] text-accent">{props.error}</span>}
        <span className="ml-auto flex items-center gap-2">
          {props.editing ? (
            <>
              <button onClick={props.onPublish} disabled={props.saving} className={`${btn} border border-rule text-ink-2 hover:text-ink`}>
                {props.status === "published" ? "Unpublish" : "Publish"}
              </button>
              {props.exists && (
                <button onClick={props.onDelete} className={`${btn} border border-rule text-ink-2 hover:text-accent`}>
                  Delete
                </button>
              )}
              <button onClick={props.onDone} className={`${btn} border border-rule text-ink-2 hover:text-ink`}>
                Done
              </button>
              <button
                onClick={props.onSave}
                disabled={props.saving || !props.dirty}
                className={`${btn} bg-accent font-medium text-white disabled:opacity-50`}
              >
                {props.saving ? "Saving…" : "Save"}
              </button>
            </>
          ) : (
            <button onClick={props.onEdit} className={`${btn} flex items-center gap-1.5 bg-accent font-medium text-white`}>
              <Icon name="pencil" width="15" height="15" /> Edit
            </button>
          )}
        </span>
      </div>
    </BottomBar>
  );
}
